module.exports = __webpack_public_path__ + "img/admin_adv_22.598aab74.png";